import gsap from "gsap";

export function playProjectsIntro() {
  const overlay = document.querySelector("#time-freeze");

  const tl = gsap.timeline();

  tl.from("#projects-content", {
    opacity: 0,
    y: 30,
    duration: 1,
    ease: "power3.out",
  })

    .to(overlay, {
      opacity: 1,
      duration: 0.25,
      ease: "power2.out",
    })

    .to(overlay, {
      opacity: 0,
      duration: 0.45,
      delay: 0.2,
      ease: "power2.in",
    });
}
